import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import HeaderEntreprise from '../../header/headerEntreprise';
import CandidatureDetailsCommon from '../../commun/CandidatureDetailsCommon';
import CustomAlert from '../../commun/CustomAlert';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer';
import NotFound404 from '../../commun/NotFound404';

const DetailsCandidature = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const authToken = localStorage.getItem('authToken');
  const connectedRecruiterId = localStorage.getItem("userId");

  const [candidature, setCandidature] = useState(null);
  const [editedStatut, setEditedStatut] = useState(null);
  const [messageEntreprise, setMessageEntreprise] = useState(candidature?.messageEntreprise || '');
  const [raisonRefus, setRaisonRefus] = useState(candidature?.raisonRefus || '');
  const [dateEntretien, setDateEntretien] = useState([]);
  const [bloqueSauvegarde, setBloqueSauvegarde] = useState(null);
  const [selectedTarif, setSelectedTarif] = useState(null);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [notFound, setNotFound] = useState(false);
  const setAlert = (severity, message) => {
    setAlertSeverity(severity);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  useEffect(() => {
    if (!authToken) return navigate('/');
    const fetchEntrepriseId = async () => {
      try {
        const resProfile = await fetch(`${API_BASE}/api/entreprise/profil/${connectedRecruiterId}`, {
          headers: { Authorization: `Bearer ${authToken}` }
        });
        if (resProfile.ok) {
          const entreprise = await resProfile.json();
          localStorage.setItem("entrepriseId", entreprise._id);
        }
      } catch (err) {
        console.error("Erreur lors de la récupération de l'entreprise", err);
      }
    };
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/candidatures/${id}`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        if (!res.ok) {
          setNotFound(true);
          return;
        }   
        const data = await res.json();
        const connectedEntrepriseId = localStorage.getItem("entrepriseId");
        if (data.entrepriseId !== connectedEntrepriseId) {
          setNotFound(true); 
          return;
        }
        
        setCandidature(data);
        setEditedStatut(data.statut);
        setMessageEntreprise(data.messageEntreprise || '');
        setRaisonRefus(data.raisonRefus || '');
        setDateEntretien(
          Array.isArray(data.dateEntretien)
            ? data.dateEntretien
            : [data.dateEntretien].filter(Boolean)
        );
        setBloqueSauvegarde(data.bloqueSauvegarde);
      } catch (err) {
        setAlert('error', 'Erreur lors du chargement de la candidature');
      }
    };
    fetchData();
  }, [id, authToken, API_BASE, navigate]);
  
  const handleSave = async () => {
    if (
      editedStatut === 'Accepté pour entretien' &&
      (!dateEntretien || dateEntretien.length === 0)
    ) {
      setAlert('error', "La date d'entretien est obligatoire.");
      return;
    }
  
    if (
      (editedStatut === 'Refusé avant entretien' || editedStatut === 'Non retenu après entretien') &&
      !raisonRefus.trim()
    ) {
      setAlert('error', 'La raison du refus est obligatoire.');
      return;
    }
  
    if (editedStatut === 'Recrutement confirmé' && !selectedTarif) {
      setAlert('error', 'Veuillez sélectionner un tarif.');
      return;
    }
  
    const payload = {
      statut: editedStatut,
      messageEntreprise,
      raisonRefus,
      dateEntretien,
      bloqueSauvegarde,
    };
  
    if (editedStatut === 'Recrutement confirmé' && selectedTarif) {
      const [typeTarif, prixTarif, deviseTarif] = selectedTarif.split(':');
      console.log('📝 Tarif choisi :', { typeTarif, prixTarif, deviseTarif });
      payload.tarifChoisi = {
        type: typeTarif,
        prix: parseFloat(prixTarif),
        devise: deviseTarif,
      };
    }
    
    try {
      const res = await fetch(`${API_BASE}/api/candidatures/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(payload),
      });
  
      if (res.ok) {
        setAlert('success', 'Statut mis à jour avec succès');
      } else {
        setAlert('error', 'Erreur lors de la mise à jour du statut');
      }
    } catch (err) {
      console.error('❌ Erreur serveur:', err);
      setAlert('error', 'Erreur serveur. Veuillez réessayer.');
    }
  };  

  const handleCancel = () => navigate('/Entreprise/Candidatures');
  if (notFound) return <NotFound404 />;

  return (
    <>
  <CandidatureDetailsCommon
  HeaderComponent={HeaderEntreprise}
  headerProps={{
    entrepriseName: localStorage.getItem('entrepriseName'),
    authToken,
    userRole: 'entreprise'
  }}
  candidature={candidature}
  editedStatut={editedStatut}
  setEditedStatut={setEditedStatut}
  messageEntreprise={messageEntreprise}
  setMessageEntreprise={setMessageEntreprise}
  raisonRefus={raisonRefus}
  setRaisonRefus={setRaisonRefus}
  dateEntretien={dateEntretien}
  setDateEntretien={setDateEntretien}
  bloqueSauvegarde={bloqueSauvegarde}
  setBloqueSauvegarde={setBloqueSauvegarde}
  selectedTarif={selectedTarif}           
  setSelectedTarif={setSelectedTarif}
  onCancel={handleCancel}
  onSave={handleSave}
  API_BASE={API_BASE}
  editable={true}
/>
<Footer />

<Chatbox userRole="entreprise" />
</>
  );
};

export default DetailsCandidature;
